/**
 * Access requests page tours. Each tab has its own guide because users and
 * request managers have different tasks on this page.
 */

export const ACCESS_REQUESTS_USER_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Track your access requests',
    description:
      'See every app access request you submitted from Discover and follow its progress here.',
    position: 'center',
  },
  {
    id: 'summary',
    title: 'Status summary',
    description:
      'These totals show how many of your requests are pending, provisioned, or rejected.',
    element: '[data-tour="access-requests-stats"]',
    position: 'bottom',
    spotlight: true,
  },
  {
    id: 'request-list',
    title: 'Request progress',
    description:
      'Each request shows when it was submitted, its current status, and any rejection reason.',
    element: '[data-tour="access-requests-user-list"]',
    position: 'top',
    spotlight: true,
  },
  {
    id: 'wiki',
    title: 'More help',
    description: 'Open the User Tab Wiki for the full access-request guide.',
    element: '[data-tour="access-requests-wiki"]',
    position: 'left',
    spotlight: true,
  },
];

export const ACCESS_REQUESTS_ADMIN_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Manage access requests',
    description:
      'Review access requests, complete provisioning in the upstream system, and record the outcome here.',
    position: 'center',
  },
  {
    id: 'summary',
    title: 'Queue summary',
    description:
      'These totals summarize the pending, provisioned, and rejected requests in the current queue.',
    element: '[data-tour="access-requests-stats"]',
    position: 'bottom',
    spotlight: true,
  },
  {
    id: 'filters',
    title: 'Filter the queue',
    description: 'Choose a status to focus the queue on the requests you need to review.',
    element: '[data-tour="access-requests-admin-filters"]',
    position: 'bottom',
    spotlight: true,
  },
  {
    id: 'queue',
    title: 'Review and decide',
    description:
      'Expand a row for details. After granting access upstream, mark it provisioned—or reject it with a reason.',
    element: '[data-tour="access-requests-admin-queue"]',
    position: 'top',
    spotlight: true,
  },
  {
    id: 'wiki',
    title: 'Admin instructions',
    description: 'Open the Admin Tab Wiki for the complete provisioning procedure.',
    element: '[data-tour="access-requests-wiki"]',
    position: 'left',
    spotlight: true,
  },
];
